import { OlympusConstants } from 'olympus';
export * from './cuisines.js';
/** @deprecated Please use OlympusConstants.auth.AUDIENCES */
export const AUDIENCES = OlympusConstants.auth.AUDIENCES;
export var DayOfWeek;
(function (DayOfWeek) {
    DayOfWeek["Sunday"] = "sunday";
    DayOfWeek["Monday"] = "monday";
    DayOfWeek["Tuesday"] = "tuesday";
    DayOfWeek["Wednesday"] = "wednesday";
    DayOfWeek["Thursday"] = "thursday";
    DayOfWeek["Friday"] = "friday";
    DayOfWeek["Saturday"] = "saturday";
})(DayOfWeek || (DayOfWeek = {}));
export const isErrorWithMessage = (payload) => {
    return typeof payload === 'object' && !!payload && 'message' in payload;
};
export const getErrorMessage = (payload, fallbackError) => {
    return isErrorWithMessage(payload) ? payload.message : fallbackError;
};
export const isACLError = (payload) => {
    return (typeof payload === 'object' &&
        !!payload &&
        payload.name === 'ACLError');
};
//# sourceMappingURL=index.js.map